import React, { FC, useContext } from "react";
import { Collapse, Divider, IconButton, List, Paper, Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { FILTERS } from "../../constants";
import { VisibilityContext } from "../../context";
import NavigationList from "./NavigationList";
import SearchSection from "./SearchSection";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: 24,
    },
    header: {
      color: theme.palette.secondary.dark,
    },
    subHeader: {
      color: theme.palette.primary.dark,
      display: "flex",
      justifyContent: "space-between",
    },
    divider: {
      height: 2,
      backgroundColor: theme.palette.primary.dark,
      marginTop: "0.5rem",
      marginBottom: "0.5rem",
    },
    listContainer: {
      padding: 0,
    },
  })
);

const FilterNavigation: FC = () => {
  const classes = useStyles();

  const [visibilityContext, setVisibilityContext] = useContext(VisibilityContext);

  const handleVisibility = () => {
    setVisibilityContext({
      ...visibilityContext,
      navigation: !visibilityContext.navigation,
    });
  };

  return (
    <Paper className={classes.container} elevation={2}>
      <div className={classes.subHeader}>
        <Typography variant="h2" className={classes.header}>
          Jump To:
        </Typography>
        <IconButton size="small" onClick={() => handleVisibility()}>
          {visibilityContext.navigation ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </div>
      <Collapse in={visibilityContext.navigation}>
        <Divider className={classes.divider} />
        <List className={classes.listContainer}>
          <SearchSection title={"Top Searches"} searches={FILTERS.OPTIONS_TOP_SEARCHES} />
          <SearchSection
            title={"Clinical Pipeline Reports"}
            searches={FILTERS.REPORT_FILTERS}
            showNewIconNextToTitle={false}
            onlyOneSelection={true}
          />
          <NavigationList title={"Stages"} section={"stages"} options={FILTERS.OPTIONS.stages} />
          <NavigationList
            title={"Submission Types"}
            section={"submissionTypes"}
            options={FILTERS.OPTIONS.submissionTypes}
          />
          <NavigationList
            title={"FDA Designations"}
            section={"fdaDesignations"}
            options={FILTERS.OPTIONS.fdaDesignations}
          />
        </List>
      </Collapse>
    </Paper>
  );
};

export default FilterNavigation;
